import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { activationService } from '../services/activationService';
import { ActivationEventType } from '../types/mode.types';
import { v4 as uuidv4 } from 'uuid';

// Session ID management - persisted in sessionStorage for the browser session
const SESSION_STORAGE_KEY = 'seo_engine_session_id';

function getOrCreateSessionId(): string {
  let sessionId = sessionStorage.getItem(SESSION_STORAGE_KEY);
  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem(SESSION_STORAGE_KEY, sessionId);
  }
  return sessionId;
}

export function useActivationMetrics(siteId: number | undefined) {
  return useQuery({
    queryKey: ['activation-metrics', siteId],
    queryFn: () => activationService.getMetrics(siteId!),
    enabled: !!siteId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useTrackEvent(siteId: number) {
  const queryClient = useQueryClient();
  const sessionId = getOrCreateSessionId();

  return useMutation({
    mutationFn: (params: { 
      eventType: ActivationEventType; 
      metadata?: Record<string, any> 
    }) => activationService.trackEvent(siteId, {
      eventType: params.eventType,
      sessionId,
      metadata: params.metadata
    }),
    onSuccess: () => {
      // Don't invalidate immediately to prevent duplicate API calls
      // Metrics will be refetched when they become stale (5 minutes)
    },
  });
}
